import { render, staticRenderFns } from "./PacienteFichaCobrancaPesquisa.vue?vue&type=template&id=2cbdf1c3&scoped=true"
import script from "./PacienteFichaCobrancaPesquisa.vue?vue&type=script&lang=js"
export * from "./PacienteFichaCobrancaPesquisa.vue?vue&type=script&lang=js"
import style0 from "./PacienteFichaCobrancaPesquisa.vue?vue&type=style&index=0&id=2cbdf1c3&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbdf1c3",
  null
  
)

export default component.exports